import { LOCALES } from 'i18n/locales';

export const highContrastButtonIntl = {
    [LOCALES.ENGLISH]: {
        'highContrast.altText': 'High contrast mode'
    },
    [LOCALES.WELSH]: {
        'highContrast.altText': 'Modd cyferbynnedd uchel'
    }
};
